import { faKitMedical } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useMemo } from "react";
import { Treatment } from "../../queries/models/treatment.model";

export interface PlannedTreatmentProps {
  treatment: Treatment;
  onSelected?: (t: Treatment) => void;
}

export function PlannedTreatment({ treatment, onSelected }: PlannedTreatmentProps) {
  const text = useMemo(() => {
    const type = treatment.treatmentType?.name ?? "Zabieg";
    const horses = (treatment.horseTreatments ?? [])
      .map((ht) => ht.horse?.name ?? "")
      .filter(Boolean)
      .join(", ");
    return `${type}: ${horses}`;
  }, [treatment]);

  return (
    <div
      onClick={() => onSelected?.(treatment)}
      className="shadow-1 m-1 p-2 flex align-items-center"
      style={{ background: "#F3E5F5", color: "#4A148C", borderLeft: "4px solid #7B1FA2", cursor: "pointer" }}
    >
      <FontAwesomeIcon icon={faKitMedical} className="mr-2" />
      <span>{text}</span>
    </div>
  );
}
